import React from "react";
import { useTranslation } from "react-i18next";
import { FilterCriteria, Project, ProjectStatus, SortCriteria } from "../types";
import { STATUS_CONFIG } from "../data/mockData.ts";

interface ProjectFiltersProps {
  filters: FilterCriteria;
  sort: SortCriteria;
  onFilterChange: (newFilters: Partial<FilterCriteria>) => void;
  onSortChange: (field: keyof Project) => void;
}

const ProjectFilters: React.FC<ProjectFiltersProps> = ({
  filters,
  sort,
  onFilterChange,
  onSortChange
}) => {
  const { t } = useTranslation();
  
  return (
    <>
      {/* Filters Section */}
      <div className="bg-white rounded-lg shadow mb-6">
        <div className="p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {t('dashboard.filters.client')}
              </label>
              <input
                type="text"
                value={filters.client || ''}
                onChange={(e) => onFilterChange({ client: e.target.value })}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm 
                  focus:border-indigo-500 focus:ring-indigo-500"
                placeholder={t('dashboard.filters.clientPlaceholder')}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {t('dashboard.filters.status')}
              </label>
              <select
                value={filters.status || ''}
                onChange={(e) => onFilterChange({ status: e.target.value as ProjectStatus })}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm 
                  focus:border-indigo-500 focus:ring-indigo-500"
              >
                <option value="">{t('dashboard.filters.statusAll')}</option>
                {Object.entries(STATUS_CONFIG).map(([status, info]) => (
                  <option key={status} value={status}>{info.label}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {t('dashboard.filters.dateFrom')}
              </label>
              <input
                type="date"
                value={filters.dateFrom || ''}
                onChange={(e) => onFilterChange({ dateFrom: e.target.value })}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm 
                  focus:border-indigo-500 focus:ring-indigo-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {t('dashboard.filters.dateTo')}
              </label>
              <input
                type="date"
                value={filters.dateTo || ''}
                onChange={(e) => onFilterChange({ dateTo: e.target.value })}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm 
                  focus:border-indigo-500 focus:ring-indigo-500"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Sort Controls */}
      <div className="bg-white rounded-lg shadow mb-6">
        <div className="p-4">
          <div className="flex items-center space-x-4">
            <span className="text-sm font-medium text-gray-700">{t('dashboard.sort.label')}</span>
            <button
              onClick={() => onSortChange('name')}
              className={`px-3 py-1 rounded-md ${
                sort.field === 'name' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100'
              }`}
            >
              {t('dashboard.sort.name')} {sort.field === 'name' && (sort.direction === 'asc' ? '↑' : '↓')}
            </button>
            <button
              onClick={() => onSortChange('client')}
              className={`px-3 py-1 rounded-md ${
                sort.field === 'client' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100'
              }`}
            >
              {t('dashboard.sort.client')} {sort.field === 'client' && (sort.direction === 'asc' ? '↑' : '↓')}
            </button>
            <button
              onClick={() => onSortChange('createdAt')}
              className={`px-3 py-1 rounded-md ${
                sort.field === 'createdAt' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100'
              }`}
            >
              {t('dashboard.sort.date')} {sort.field === 'createdAt' && (sort.direction === 'asc' ? '↑' : '↓')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

  export default ProjectFilters;